import { API, Auth } from "aws-amplify";
import { Modal } from "antd";

let isModalOpen = false;

async function checkAndHandleSessionExpired(e) {
  const errorCode = e?.response?.status;
  try {
    await Auth.currentSession();
  } catch {
    return triggerLogoutModal();
  }
  if (errorCode === 500 || errorCode === 403) {
    return triggerLogoutModal();
  }
}

function triggerLogoutModal() {
  if (isModalOpen) return;

  isModalOpen = true;
  Modal.error({
    title: "Session Expired",
    content: "Your session has expired or your account was removed. Please log in again.",
    okText: "Login",
    onOk: async () => {
      try {
        await Auth.signOut();
      } catch (logoutError) {
        console.error("Logout failed:", logoutError);
      }
      localStorage.clear();
      window.location.href = "/login";
    },
  });
}


export async function getCall(path) {
  try {
    const data = await API.get("list", path, {});
    return { data, statusCode: 1 };
  } catch (e) {
    alert(e?.response?.data?.message || "Something went wrong!");
    await checkAndHandleSessionExpired();
    return { data: {}, statusCode: 0 };
  }
}

export async function listCall(path) {
  try {
    const data = await API.get("list", path, {});
    return { data, statusCode: 1 };
  } catch (e) {
    alert(e?.response?.data?.message || "Something went wrong!");
    await checkAndHandleSessionExpired(e);
    return { data: [], statusCode: 0 };
  }
}

export async function postCall(path, data, disableAlert) {
  try {
    const res = await API.post("create", path, {
      body: { entityData: data },
    });
    return { data: res, statusCode: 1 };
  } catch (e) {
    if (!disableAlert) {
      alert(e?.response?.data?.message || "Something went wrong!");
    }
    await checkAndHandleSessionExpired();
    return { data: e, statusCode: 0 };
  }
}

export async function putCall(path, data) {
  try {
    await API.put("update", path, {
      body: { entityData: data },
    });
    return { data: "Successfully updated!", statusCode: 1 };
  } catch (e) {
    alert(e?.response?.data?.message || "Something went wrong!");
    await checkAndHandleSessionExpired();
    return { data: e, statusCode: 0 };
  }
}

export async function delCall(path) {
  try {
    const data = await API.del("delete", path, {});
    return { data, statusCode: 1 };
  } catch (e) {
    alert(e?.response?.data?.message || "Something went wrong!");
    await checkAndHandleSessionExpired();
    return { data: e, statusCode: 0 };
  }
}

export async function delOrg(path, payload = {}) {
  try {
    const data = await API.del("delete", path, {
      body: payload,
    });
    return { data, statusCode: 1 };
  } catch (e) {
    alert(e?.response?.data?.message || "Something went wrong!");
    await checkAndHandleSessionExpired();
    return { data: e, statusCode: 0 };
  }
}

export async function rawPostCall(path, data, disableAlert) {
  try {
    const res = await API.post("create", path, {
      body: { entityData: data },
    });
    return { data: res, statusCode: 1 };
  } catch (e) {
    if (!disableAlert) {
      alert(e?.response?.data?.message || "Something went wrong!");
    }
    await checkAndHandleSessionExpired();
    return { data: e, statusCode: 0 };
  }
}

